"use client";
import {axiosInstance} from "@/app/api";

const getfleetdatas = async (userid: any): Promise<any> => {
  const url = "/api/expense/settings/list?loginUserId=" + userid;
  return await axiosInstance().get(url);
};

const addfleetdata = async (requestdata: any, userid: any): Promise<any> => {
  const url = "/api/expense/settings/add?loginUserId=" + userid;
  return await axiosInstance().post(url, requestdata);
};

const updatefleetdata = async (requestdata: any, userid: any): Promise<any> => {
  const url = "/api/expense/settings/edit?loginUserId=" + userid;
  return await axiosInstance().post(url, requestdata);
};

const deletefleetdata = async (requestdata: any, userid: any): Promise<any> => {
  const url = "/api/expense/settings/delete?loginUserId=" + userid;
  return await axiosInstance().post(url, requestdata);
};

export const FleetService = {
  getfleetdatas,
  addfleetdata,
  updatefleetdata,
  deletefleetdata
};
